export const constants = {
    // api : "http://ec2-13-127-43-135.ap-south-1.compute.amazonaws.com:3001",
     api : "http://localhost:3001",
    webHost:"http://angularfront.s3-website.ap-south-1.amazonaws.com/",
    invalidLogin : "invalid login criteria. please check your credentials and try again.",
    somethingWrong : "Something went wrong please try again.",
    recordSaved : "Record has been saved successfully."
} 